/* This is a generated file. Do not edit manually. */
import React from 'react';
import PropTypes from 'prop-types';
import iconSizes from '../../iconSizes';

/**
 * AlertTriangleIcon
 */
export default class AlertTriangleIcon extends React.Component {
  static propTypes = {
    /** The size of the icon */
    size: PropTypes.oneOf(['s', 'm', 'l', 'xl']),
    /** The color of the icon */
    color: PropTypes.string.isRequired
  };

  static defaultProps = {
    size: 'm',
    color: 'black'
  };

  render() {
    const { size: sizeProp, color } = this.props;
    const size = correctButtonSize(sizeProp);
    return (
      <svg
        focusable="false"
        xmlns="http://www.w3.org/2000/svg"
        viewBox={'0 0 32 32'}
        style={{ width: iconSizes[size], height: iconSizes[size] }}
      >
        <g style={{ fill: color }}>
          <svg viewBox="0 0 24 24"><path d="M23 17.5L14.5 3.3c-.9-1.3-2.7-1.8-4.1-1-.4.3-.7.6-1 1L.9 17.5c-.4.7-.5 1.5-.3 2.3.2.8.7 1.4 1.3 1.8.5.3 1 .5 1.6.5h16.9c1.7 0 3-1.3 3-3 0-.6-.2-1.2-.4-1.6zM20.4 20H3.5c-.2 0-.3 0-.5-.2-.2-.1-.4-.3-.4-.6 0-.2-.1-.4.1-.7l8.5-14.1c.1-.2.2-.3.3-.4.5-.3 1.1-.1 1.4.3l8.4 14.1c.1.1.1.3.1.4 0 .8-.4 1.2-1 1.2zM12 8c-.6 0-1 .4-1 1v4c0 .6.4 1 1 1s1-.4 1-1V9c0-.6-.4-1-1-1zm0 10.25a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5z"/><use/></svg>
        </g>
      </svg>
    );
  }
}

/* corrects deprecated api, can be removed in future release */
function correctButtonSize(size) {
  switch (size) {
    case 'medium':
      return 'm';
    case 'small':
      return 's';
    case 'large':
      return 'l';
    case 'xlarge':
      return 'xl';
    default:
      return size;
  }
}

